const queryShadowRoot = (root, maxDepth = 600, depth = 0) => {
  const isFocusable = ($elem) => $elem.hasAttribute("tabindex") || ($elem instanceof HTMLAnchorElement || $elem instanceof HTMLAreaElement) && $elem.hasAttribute("href") || $elem instanceof HTMLButtonElement || $elem instanceof HTMLInputElement || $elem instanceof HTMLTextAreaElement || $elem instanceof HTMLSelectElement || $elem instanceof HTMLIFrameElement;
  const matches = [];
  if (depth >= maxDepth) {
    return matches;
  }
  const traverseSlot = ($slot) => {
    const assignedNodes = $slot.assignedNodes().filter((node) => node.nodeType === 1);
    if (assignedNodes.length > 0) {
      const $slotParent = assignedNodes[0].parentElement;
      return queryShadowRoot($slotParent, maxDepth, depth + 1);
    }
    return [];
  };
  const children = Array.from(root.children || []);
  if (root instanceof HTMLElement && root.tagName && children.length === 0) {
    children.push(root);
  }
  for (const $child of children) {
    if (isFocusable($child)) {
      matches.push($child);
    }
    if ($child.shadowRoot != null) {
      matches.push(...queryShadowRoot($child.shadowRoot, maxDepth, depth + 1));
    } else if ($child.tagName === "SLOT") {
      matches.push(...traverseSlot($child));
    } else {
      matches.push(...queryShadowRoot($child, maxDepth, depth + 1));
    }
  }
  return matches.filter((c, index) => matches.indexOf(c) === index);
};
export {
  queryShadowRoot
};
//# sourceMappingURL=query-shadow-root.js.map
